// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MemberDirectoryPage_wrapper__YzF8z","sidebar":"MemberDirectoryPage_sidebar__TepTT"};